import { css } from '@emotion/react';
import styled from '@emotion/styled';

export default function ExploreBanner() {
  return <Container />;
}

const Container = styled.div`
  ${({ theme }) => css`
    width: 90%;
    max-height: 448px;
    margin: 0 auto;
    border-radius: 24px;
    background-color: ${theme.backgroundColor.bg_dark_2};
    ${theme.mixins.aspectRatio.ratio5_6};
  `}
`;
